import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Proveedor } from '../../models/t2_proveedores.model';
import { ProveedoresService } from '../../services/proveedores.service';
import { environment } from './../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';

import $ from 'jquery';
import { RouterLink } from '@angular/router';
declare var bootstrap: any;

@Component({
  selector: 'app-admin-proveedores',
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './admin-proveedores.component.html',
  styleUrl: './admin-proveedores.component.css'
})
export class AdminProveedoresComponent {

  public env = environment;
  
  usuarios: Proveedor[] = [];
  usuario: Proveedor = new Proveedor();
  usuario_find: Proveedor = new Proveedor();

  // Control de botones y estados
  btn: boolean = true;
  ready: boolean = false;
  searchTerm: string = '';

  // Paginación
  pages: any[] = [{}];
  pageActive: number = 1;
  pageSize: number = 20;

  // Proveedor logueado
  login_user: any;
    
  constructor(
    private auth: AuthService,
    private service: ProveedoresService,
    private toastr: ToastrService
  ){
    this.usuario_find = new Proveedor();
    this.login_user = this.auth.login_user;
  }
    
  ngOnInit(): void {
    //this.paginar();
  }

  paginar(){
    this.ready = false;
    this.usuario_find.t2_razon = this.searchTerm;
    this.service.getPages(this.pageSize, this.usuario_find).subscribe(
      res => {
        console.log(res);
        if (res.length < this.pageActive) {
          if (this.searchTerm.trim() === "") {
            this.pageActive = res.length;
          } else {
            this.pageActive = 1;
          }
        }
        this.pages = res;
        this.getData(this.pageActive);
      },
      err => {
        console.error(err);
        this.ready = true;
        this.toastr.error('Error al cargar las páginas', 'Error');
      }
    );   
  }

  getData(page: number) {
    this.ready = false;
    this.pageActive = page;
    try {
        this.service.getDataFilter(this.pages[page - 1], this.usuario_find).subscribe(
          res => {
            console.log('Proveedors cargados:', res);
            this.usuarios = res;
            this.ready = true;
          },
          err => {
            console.error(err);
            this.ready = true;
            this.toastr.error('Error al cargar usuarios', 'Error');
          }
        );
    } catch (error) {
        console.error(error);
        this.pageActive -= 1;
        if (this.pageActive > 0) {
          this.service.getDataFilter(this.pages[this.pageActive - 1], this.usuario_find).subscribe(
            res => {
              this.usuarios = res;
              this.ready = true;
            },
            err => {
              console.error(err);
              this.ready = true;
              this.toastr.error('Error al cargar usuarios', 'Error');
            }
          );
        } else {
          this.ready = true;
        }
    }
    

  }

  closeForm(): void {
    const modalElement = document.getElementById('modalAdd');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement);
      modal.hide();
    }
    this.usuario = new Proveedor();
  }

  closeConfirm(): void {
    const modalElement = document.getElementById('modalEliminar');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement);
      modal.hide();
    }
    this.usuario = new Proveedor();
  }

  resetForm(): void {
    this.usuario = new Proveedor();
  }

  edit(usuario: Proveedor): void {
    this.usuario = {...usuario};
  }

  submit(): void {
    this.btn = false;
    if (this.usuario.t2_id == null) {
      // Crear nuevo usuario
      this.service.postData(this.usuario)
        .subscribe(
          (response) => {
            this.btn = true;
            this.toastr.success('Elemento creado exitosamente', 'Éxito');
            this.closeForm();
            this.paginar();
          },
          (error) => {
            this.btn = true;
            console.error('Error al crear elemento:', error);
            this.toastr.error('No se pudo crear el elemento', 'Error');
          }
        );
    } else {
      // Actualizar usuario existente
      this.service.putData(this.usuario)
        .subscribe(
          (response) => {
            this.btn = true;
            this.toastr.success('Elemento actualizado exitosamente', 'Éxito');
            this.closeForm();
            this.paginar();
          },
          (error) => {
            this.btn = true;
            console.error('Error al actualizar elemento:', error);
            this.toastr.error('No se pudo actualizar el elemento', 'Error');
          }
        );
    }
  }


  eliminar(usuario: any): void {
    if (usuario.t2_id) {
      this.btn = true;
      this.usuario = {...usuario};
    } else {
      this.btn = false;
      this.service.deleteData(this.usuario)
        .subscribe(
          (response) => {
            this.btn = true;
            this.toastr.success('Elemento eliminado exitosamente', 'Éxito');
            this.paginar();
            this.closeConfirm();
          },
          (error) => {
            console.error('Error al eliminar elemento:', error);
            this.btn = true;
            this.toastr.error('No se pudo eliminar el elemento', 'Error');
          }
        );
    }
  }


}
